import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/buyer/notifications")({
	component: RouteComponent
});

function RouteComponent() {
	return <div>Hello "/buyer/notifications"!</div>;
}
